import { Navigate } from 'react-router-dom';

import useAuth from 'global/Auth/use';

import {
  RelationTypeEnum as RelationType,
  RelationType as RelationTypeDTO,
} from 'api/Types';

export const NO_TENANT_URL = '/escritorios';

const FallBackRoute = {
  [RelationType.Owner]: 'escritorio',
  [RelationType.Employee]: 'escritorio',
  [RelationType.Client]: 'cliente/documents', //? Portal do Cliente (antes 'dashboard', rota inexistente - B-32)
  [RelationType.TaxClaimant]: 'txclmt/documents',
};

interface PrivateRouteProps {
  component: React.ComponentType;
  allowed?: RelationTypeDTO | 'admin';
}

const PrivateRoute = ({
  component: RouteComponent,
  allowed,
}: PrivateRouteProps) => {
  console.log('Rota')!;

  const currentLogin = useAuth((state) => state.data);
  const isAuth = useAuth((state) => state.isAuth);

  const { user, relationType } = currentLogin || {};

  let role = relationType;

  // Verifica autenticação
  if (!isAuth || currentLogin === null || user == null) {
    return <Navigate to="/login" replace />;
  }

  //? Sem tenant selecionado, manda para seleção de escritório
  if (allowed !== undefined && role === undefined) {
    return <Navigate to={NO_TENANT_URL} replace />;
  }

  if (role === RelationType.Owner) {
    role = RelationType.Employee;
  }

  if (role === allowed || allowed === undefined) {
    return <RouteComponent />;
  } else if (allowed === 'admin' && currentLogin?.isAdmin) {
    return <RouteComponent />;
  } else {
    const fallbackPath =
      FallBackRoute[role as RelationTypeDTO] || '/maintenance';
    return <Navigate to={`/${fallbackPath}`} replace />;
  }
};

export default PrivateRoute;
